export default "__VITE_ASSET__128d1510__"